import {useContext} from 'react';
import {GlobalContext} from '../../../../../utilities/GlobalContext';
import signIn from '../../../../../api/auth/signIn';
import slideSystem from '../../slideSystem';
import Slide1 from './Slide1';

function ExportSlides() {
	let serverOrigin = useContext(GlobalContext).serverOrigin;
	let user = useContext(GlobalContext).user;
	let setUser = useContext(GlobalContext).setUser;
	let slides = [Slide1];
	let mainSlides = slideSystem(slides, {
		done: done,
		next: next,
	});

	return mainSlides;

	function next(userFrag, options = {}) {
		let userBuffer = user || {};
		for (let property in userFrag) {
			userBuffer[property] = userFrag[property];
			setUser(userBuffer);
		}
		if (options.createUser) {
			let user = cleanUser(userBuffer);
			signIn(user.email, setUser, serverOrigin)
				.then(() => {
					alert('Successfully signed in');
					window.location.href = '/home';
				})
				.catch(() => {
					alert('Failed to create account');
					window.location.href = '/signin';
				});
		}
	}
	function done() {}
	function cleanUser(inUser) {
		let user = {
			email: inUser.email || 'error',
		};

		user.a1 = inUser.a1 || null;
		user.a2 = inUser.a2 || null;
		user.a3 = inUser.a3 || null;
		user.a4 = inUser.a4 || null;
		user.age = inUser.age || null;
		user.listOfGoals = inUser.listOfGoals || null;

		return user;
	}
}

export default ExportSlides;
